/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc douYin取消订单，抖音下单失败时，小程序调用，不给其他端调用
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/order/douYinOrder/cancel/${orderId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
